var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { ButtonStructure } from '../components/ButtonStructure';
// Styles
import { getButtonStylesBySize } from './getButtonStylesBySize';
import { getButtonStyles } from '../../../common/styles/button/styles/getButtonStyles';
import { getButtonStylesByVariant } from './getButtonStylesByVariant';
import { getButtonStylesByShape } from './getButtonStylesByShape';
// Utils
import styled from 'styled-components';
export var StyledButton = styled(ButtonStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", "\n  ", ";\n\n  grid-template-columns: repeat(3, minmax(0px, auto));\n"], ["\n  ", ";\n  ", ";\n  ", "\n  ", ";\n\n  grid-template-columns: repeat(3, minmax(0px, auto));\n"])), function (_a) {
    var disabled = _a.disabled;
    return getButtonStyles(disabled);
}, function (_a) {
    var size = _a.size;
    return getButtonStylesBySize(size);
}, function (_a) {
    var disabled = _a.disabled, styleVariant = _a.styleVariant, theme = _a.theme;
    return getButtonStylesByVariant(disabled, styleVariant, theme);
}, function (_a) {
    var shape = _a.shape;
    return getButtonStylesByShape(shape);
});
var templateObject_1;
//# sourceMappingURL=StyledButton.js.map